import {Card} from "@mui/material";
import {contentPad, userContentCss} from "../TaskEvents";
import {TaskEvent} from "../../../api/Tasks2";
import {useContext, useState} from "react";
import {useUser} from "../../../misc/Permission";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {ComposeInner} from "../Compose";
import {api} from "../../../api/API";
import {Task2CardContext} from "./Task2CardContext";
import {useConfirm} from "../../../misc/Confirm";
import {useAsyncAction} from "nate-react-api-helpers";

export function CommentView(props: {
    value: TaskEvent;
}) {
    const v = props.value;
    const [edit, setEdit] = useState(false);
    const u = useUser();
    const isMine = u?.id === props.value.commentObj.createdBy
    const ctx = useContext(Task2CardContext);
    const confirm = useConfirm();

    const remove = useAsyncAction(async (input) => {
        await api.tasks2.updateComment(input);
        ctx.reload();
    }, []);

    return (
        <>
            {!edit && <Card variant="outlined" style={contentPad}>
                <div className={userContentCss} dangerouslySetInnerHTML={{__html: v.commentObj.body}}></div>
            </Card>}
            {edit && <ComposeInner defaultValue={v.commentObj.body}
                                   onSubmit={async (value) => {
                                       await api.tasks2.updateComment(Object.assign({}, props.value.commentObj, {
                                           body: value,
                                       }));

                                       setEdit(false);
                                       ctx.reload();
                                   }}
                                   onCancel={() => {
                                       setEdit(false);
                                   }} />}
            {isMine && <div>
                <button className={linkButton} onClick={() => setEdit(true)}>edit</button>
                <button className={linkButton} onClick={async () => {
                    const ok = await confirm.confirm("Are you sure you want to remove this?")
                    if(ok) {
                        remove.callback(Object.assign({}, props.value.commentObj, {
                            archived: true,
                        }))
                    }
                }}>delete</button>
                {remove.LoadingElement}
            </div>}
        </>
    )
}

const linkButton = css({
    background: "none",
    textDecoration: "underline",
    color: grey["800"],
    textAlign: "left",
    cursor: "pointer",
    border: "none",
    lineHeight: "1em",
})